import React from "react";
import './ProductSkeleton.css'; // Importamos el CSS

const ProductSkeleton = () => {
  return (
    <div className="skeleton-container">
      {/* Imagen */}
      <div className="skeleton-box image" />

      {/* Nombre del producto */}
      <div className="skeleton-box title-short" />
      <div className="skeleton-box title-long" />
 

      {/* Selector cantidad */}
      <div className="skeleton-quantity">
        <div className="skeleton-box qty" />
        <div className="skeleton-box qty-large" />
        <div className="skeleton-box qty" />
      </div>

      {/* Botón Agregar */}
      <div className="skeleton-box button" />
 
    </div>
  );
};

export default ProductSkeleton;
